{
  "action": {
    "label": "Acción"
  },
  "actionType": {
    "label": "Tipo de acción",
    "value": {
      "alert": "Alerta",
      "dvtm": "DVTM",
      "external_platform": "Plataforma externa",
      "group": "Grupo",
      "iam": "IAM",
      "platform": "Plataforma",
      "profile": "Perfil",
      "sector": "Red",
      "talq_gateway": "Pasarela TALQ",
      "user": "Usuario"
    }
  },
  "export": {
    "error": "Se ha producido un error durante la generación del fichero CSV",
    "label": "Exportar",
    "tooltip": "Seleccionar líneas para poder exportarlas en formato CSV"
  },
  "eventType": {
    "label": "Tipo de evento",
    "value": {
      "cyber": "Ciber",
      "device": "Equipo",
      "device_fleet": "Parque de dispositivos",
      "system": "Sistema"
    }
  },
  "level": {
    "label": "Nivel de información",
    "value": {
      "info": "Información",
      "warning": "Alerta",
      "error": "Error",
      "critical": "Crítico"
    }
  },
  "timestamp": {
    "label": "Indicación de fecha y hora"
  },
  "filters": {
    "actions": {
      "placeholder": "Buscar por acción",
      "empty": "No se ha encontrado ninguna acción",
      "actionFound": "No se encontraron acciones | Se encontraron {count} acciones | Se encontraron {count} acciones"
    },
    "applications": {
      "declination": {
        "empty": "Ninguna aplicación"
      },
      "label": "Aplicación",
      "placeholder": "Buscar por aplicación",
      "type": {
        "empty": "Ningún tipo"
      }
    },
    "clear": {
      "label": "Eliminar los filtros"
    },
    "componentId": {
      "label": "Identificador de componente",
      "value": {
        "all": "Todos"
      }
    },
    "dropdown": {
      "applyAsAFilter": "Aplicar como filtro",
      "button": {
        "label": "Filtros",
        "title": "Mostrar los filtros"
      },
      "properties": {
        "device": "Propiedades del equipo",
        "email_address": "Propiedades del correo electrónico",
        "gateway": "Propiedades de la pasarela",
        "group": "Propiedades del grupo",
        "platform": "Propiedades de la plataforma",
        "profile": "Propiedades del perfil",
        "sector": "Propiedades de la red",
        "user": "Propiedades del usuario",
        "pki_config": "Propiedades de PKI",
        "interface": "Propiedades de la interfaz"
      }
    },
    "entityClass": {
      "label": "Categoría de autor o activo",
      "value": {
        "device": "Equipo",
        "email_address": "Dirección e-mail",
        "gateway": "Pasarela",
        "group": "Grupo",
        "platform": "Plataforma",
        "profile": "Perfil",
        "role": "Función",
        "sector": "Red",
        "user": "Usuario"
      }
    },
    "entity": {
      "label": "Autor o activo"
    },
    "sortBy": {
      "label": "Tri",
      "value": {
        "datetime": "Cronológico"
      }
    },
    "sortDirection": {
      "label": "Orden",
      "value": {
        "asc": "Creciente",
        "desc": "Decreciente"
      }
    },
    "startDate": {
      "label": "Fecha de inicio"
    },
    "status": {
      "label": "Error"
    },
    "timestamp": {
      "formatter": "DD/MM/YYYY",
      "periodSeparator": "al",
      "placeholder": "Seleccione un período"
    },
    "users": {
      "placeholder": "Buscar usuarios",
      "header": "Usuarios"
    },
    "assetClass": {
      "label": "Categoría de activo",
      "value": {
        "device": "Equipo",
        "email_address": "Dirección e-mail",
        "gateway": "Pasarela",
        "group": "Grupo",
        "platform": "Plataforma",
        "profile": "Perfil",
        "sector": "Red",
        "user": "Usuario"
      }
    },
    "authorClass": {
      "label": "Categoría de autor",
      "value": {
        "device": "Equipo",
        "email_address": "Dirección e-mail",
        "gateway": "Pasarela",
        "group": "Grupo",
        "platform": "Plataforma",
        "profile": "Perfil",
        "sector": "Red",
        "user": "Usuario"
      }
    },
    "devices": {
      "header": "Equipos",
      "model": {
        "empty": "Ningún modelo"
      },
      "placeholder": "Buscar equipos",
      "type": {
        "empty": "Ningún tipo"
      }
    },
    "actionTypes": {
      "placeholder": "Buscar tipos de acción",
      "empty": "No se han encontrado tipos de acción",
      "actionTypesFound": "No se encontraron tipos de acción | Se encontró {count} tipo de acción | Se encontraron {count} tipos de acción"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "DD/MM/YYYY HH:mm:ss"
      },
      "label": {
        "label": "Nombre"
      }
    },
    "empty": "No se ha encontrado ningún registro del diario",
    "unknown": "desconocido"
  },
  "origin": {
    "label": "Origen",
    "values": {
      "mobileApplication": "Aplicación móvil",
      "device": "Equipo",
      "thirdPartyApplication": "Aplicación de terceros",
      "lxConnect": "LX CONNECT"
    }
  }
}
